function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getListAnswersWithProperKeys = listAnswers => {
  const listAnswerWithModifiedKeys = [];
  listAnswers.forEach(listAnswer => {
    if (listAnswer) {
      const newListAnswer = {};
      Object.keys(listAnswer).forEach(key => {
        let newKey = key;
        if (newKey.startsWith('_')) {
          newKey = newKey.substring(1);
        }
        newListAnswer[newKey] = listAnswer[key];
      });
      listAnswerWithModifiedKeys.push(newListAnswer);
    }
  });
  return listAnswerWithModifiedKeys;
};
const getSubQuestionWithKeys = subQuestion => {
  let value = _objectSpread({}, subQuestion);
  if (value.listAnswers) {
    const valueAsListSubAnswerRequest = value;
    valueAsListSubAnswerRequest.listAnswers = getListAnswersWithProperKeys(valueAsListSubAnswerRequest.listAnswers);
    value = valueAsListSubAnswerRequest;
  }
  return value;
};
const getAnswerWithKeys = answer => {
  const answerAsType = _objectSpread({}, answer);
  if (answerAsType.subQuestion) {
    answerAsType.subQuestion = answerAsType.subQuestion.map(sub => {
      return getSubQuestionWithKeys(sub);
    });
    return answerAsType;
  }
  answerAsType.subQuestion = [];
  return answerAsType;
};
export const createStructureForSubmit = answers => {
  const newAnswers = Object.assign([], answers);
  return newAnswers.map(answer => {
    return getAnswerWithKeys(answer);
  });
};
export default createStructureForSubmit;